import * as rules from './auth-rules';
import * as limit from './auth-limit';
import {IMenuItem} from './types';

// 平台的主菜单
const data: IMenuItem[] = [
    {
        title: '首页',
        icon: 'mdi-nav-dashboard',
        link: '/home',
        rule: rules.byAuth,
        auth: [null],
    },
    {
        title: '组织和用户',
        icon: 'mdi-nav-organize',
        rule: rules.byAuth,
        children: [
            {
                title: '会员/企业管理',
                link: '/organization/org',
                rule: rules.byAuth,
                auth: limit.org,
            },
            {
                title: '用户管理',
                link: '/organization/user',
                rule: rules.byAuth,
                auth: limit.user,
            },
            {
                title: '角色管理',
                link: '/organization/role',
                rule: rules.byAuth,
                auth: limit.user,
            },
        ],
    },
    {
        title: '基础信息',
        icon: 'mdi-nav-baseinfo',
        rule: rules.byAuth,
        children: [
            {
                title: '品牌管理',
                link: '/baseinfo/brand',
                rule: rules.byAuth,
                auth: limit.brand,
            },
            {
                title: '属性管理',
                link: '/baseinfo/property',
                rule: rules.byAuth,
                auth: limit.filter,
            },
            {
                title: '过滤管理',
                link: '/baseinfo/filter',
                rule: rules.byAuth,
                auth: limit.filter,
            },
            {
                title: '字典管理',
                link: '/baseinfo/dictionary',
                rule: rules.byAuth,
                auth: limit.dict,
            },
            {
                title: '关键字管理',
                link: '/baseinfo/keyword',
                rule: rules.byAuth,
                auth: limit.keyword,
            },
            {
                title: '公告管理',
                link: '/baseinfo/notice',
                rule: rules.byAuth,
                auth: limit.notice,
            },
            {
                title: '客户端配置',
                link: '/baseinfo/client',
                rule: rules.byAuth,
                auth: limit.client,
            },
            {
                title: '告知管理',
                link: '/baseinfo/sender-config',
                rule: rules.byAuth,
                auth: limit.notice,
            },
            {
                title: '告知模板',
                link: '/baseinfo/sender-template',
                rule: rules.byAuth,
                auth: limit.notice,
            },
            {
                title: '告知日志',
                link: '/baseinfo/sender-log',
                rule: rules.byAuth,
                auth: limit.notice,
            },
            {
                title: '定时任务',
                link: '/baseinfo/task-cron',
                rule: rules.byAuth,
                auth: limit.cron,
            },
        ],
    },
    {
        title: '物料',
        icon: 'mdi-nav-material',
        rule: rules.byAuth,
        children: [
            {
                title: '物品管理',
                link: '/materials/item',
                rule: rules.byAuth,
                auth: limit.item,
            },
            {
                title: '材料管理',
                link: '/materials/material',
                rule: rules.byAuth,
                auth: limit.item,
            },
            {
                title: '型材产品',
                link: '/materials/section-product',
                rule: rules.byAuth,
                auth: limit.sectionProduct,
            },
            {
                title: '底材管理',
                link: '/materials/basic-material',
                rule: rules.byAuth,
                auth: limit.basicMaterial,
            },
            {
                title: '物料导航',
                link: '/materials/nav',
                rule: rules.byAuth,
                auth: limit.matNav,
            },
            {
                title: '物料检索',
                link: '/materials/search',
                rule: rules.byAuth,
                auth: [null],
            },
        ],
    },
    {
        title: '拼装家具',
        icon: 'mdi-nav-furniture',
        rule: rules.byModuleCode,
        moduleCode: ['FURNITURE'],
        children: [
            {
                title: '零件管理',
                link: '/furniture/mesh',
                rule: rules.byAuth,
                auth: limit.mesh,
            },
            {
                title: '模块管理',
                link: '/furniture/block',
                rule: rules.byAuth,
                auth: limit.block,
            },
            {
                title: '家具导航',
                link: '/furniture/nav',
                rule: rules.byAuth,
                auth: limit.furNav,
            },
            {
                title: '家具检索',
                link: '/furniture/search',
                rule: rules.byAuth,
                auth: [null],
            },
        ],
    },
    {
        title: '素材',
        icon: 'mdi-nav-ue',
        rule: rules.byAuth,
        children: [
            {
                title: '模型管理',
                link: '/ue/model',
                rule: rules.byAuth,
                auth: limit.ue,
            },
            {
                title: '型材管理',
                link: '/ue/section-bar',
                rule: rules.byAuth,
                auth: limit.sectionBar,
            },
            {
                title: '材质管理',
                link: '/ue/instance',
                rule: rules.byAuth,
                auth: limit.ue,
            },
            {
                title: '贴图包管理',
                link: '/ue/texture',
                rule: rules.byAuth,
                auth: limit.ue,
            },
        ],
    },
    {
        title: '设计方案',
        icon: 'mdi-nav-design',
        rule: rules.byAuth,
        children: [
            {
                title: '专案管理',
                link: '/design/group',
                rule: rules.byAuth,
                auth: limit.dpgGroup,
            },
            {
                title: '样板间管理',
                link: '/design/blank-room',
                rule: rules.byAuth,
                auth: limit.blankRoom,
            },
            {
                title: '数字房型',
                link: '/design/digital-room',
                rule: rules.byAuth,
                auth: [null],
            },
            {
                title: '我的设计项目',
                link: '/design/acceptances',
                rule: rules.byAuth,
                auth: [null],
            },
            {
                title: '愿望单管理',
                link: '/design/favorite',
                rule: rules.byAuth,
                auth: limit.favorite,
            },
            {
                title: '企业资源定制',
                link: '/design/custom-resource',
                rule: rules.byAuth,
                auth: limit.customResource,
            },
            {
                title: '专案导航',
                link: '/design/nav',
                rule: rules.byAuth,
                auth: limit.designNav,
            },
            {
                title: '专案检索',
                link: '/design/search',
                rule: rules.byAuth,
                auth: limit.designNav,
            },
            {
                title: '杂志管理',
                link: '/design/magazine',
                rule: rules.byAuth,
                auth: limit.magazine,
            },
        ],
    },
    {
        title: '设计服务',
        icon: 'mdi-nav-design',
        rule: rules.byAuth,
        children: [
            {
                title: '接受设计项目',
                link: '/design/appointment',
                rule: rules.byAuth,
                auth: [null],
            },
            {
                title: '设计项目管理',
                link: '/design/inspections',
                rule: rules.byAuth,
                auth: [null],
            },
        ],
    },
    {
        title: '设计项目',
        icon: 'mdi-nav-design',
        rule: rules.byAuth,
        children: [
            {
                title: '我的设计项目',
                link: '/customer/project',
                rule: rules.byAuth,
                auth: [null],
            },
        ],
    },
    {
        title: '财务',
        icon: 'mdi-nav-finance',
        rule: rules.byAuth,
        children: [
            {
                title: '会员/企业激活',
                link: '/finance/activate',
                rule: rules.byAuth,
                auth: limit.orgActivate,
            },
            {
                title: '会员/企业管理',
                link: '/finance/service',
                rule: rules.byAuth,
                auth: limit.orgService,
            },
            {
                title: '价格服务管理',
                link: '/finance/matrix',
                rule: rules.byAuth,
                auth: limit.priceMatrix,
            },
            {
                title: '财务操作日志',
                link: '/finance/logs',
                rule: rules.byAuth,
                auth: limit.financeLog,
            },
        ],
    },
    {
        title: '品牌数字门店',
        icon: 'mdi-store',
        rule: rules.byModuleCode,
        moduleCode: ['BRANDED_DIGITAL_STORES'],
        children: [
            {
                title: '门店管理',
                link: '/store/shop',
                rule: rules.byAuth,
                auth: limit.brandStore,
            },
            {
                title: '内容管理',
                link: '/store/resource',
                rule: rules.byAuth,
                auth: limit.brandStoreRes,
            },
        ],
    },
    {
        title: '数字资产',
        icon: 'mdi-nav-message',
        rule: rules.byModuleCode,
        moduleCode: ['DIGITAL_ASSET'],
        children: [
            {
                title: '属性管理',
                link: '/digital-asset/attr',
                rule: rules.byAuth,
                auth: limit.assetAttr,
            },
            {
                title: '类目管理',
                link: '/digital-asset/def',
                rule: rules.byAuth,
                auth: limit.assetDef,
            },
            {
                title: '资产管理',
                link: '/digital-asset/product',
                rule: rules.byAuth,
                auth: limit.assetProduct,
            },
            {
                title: '资产检索',
                link: '/digital-asset/search',
                rule: rules.byAuth,
                auth: limit.assetRetrieve,
            },
        ],
    },
    {
        title: '官网',
        icon: 'mdi-nav-website',
        rule: rules.byAuth,
        children: [
            {
                title: '首页管理',
                link: '/portal/home',
                rule: rules.byAuth,
                auth: limit.portalHome,
            },
        ],
    },
    {
        title: '数据治理',
        icon: 'mdi-nav-data',
        rule: rules.byAuth,
        children: [
            {
                title: '数据迁出',
                link: '/data/migrate-out',
                rule: rules.byAuth,
                auth: limit.migrateOut,
            },
            {
                title: '数据迁入',
                link: '/data/migrate-in',
                rule: rules.byAuth,
                auth: limit.migrateIn,
            },
            {
                title: '清理更新',
                link: '/data/updation',
                rule: rules.byAuth,
                auth: limit.updation,
            },
        ],
    },
    {
        title: '统计与日志',
        icon: 'mdi-pie',
        rule: rules.byAuth,
        children: [
            {
                title: '账号统计',
                link: '/statistics/account',
                rule: rules.byAuth,
                auth: limit.accountStats,
            },
            {
                title: '崩溃日志',
                link: '/statistics/crash',
                rule: rules.byAuth,
                auth: [null],
            },
        ],
    },
];

export default data;
